module.exports = __webpack_public_path__ + "static/assets/c11f7047b83dc65e53cbfa9e8060fcef.png";